/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cc_LimitsInputs */

const en_cc_limits = /** @type {(inputs: Cc_LimitsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The initial adapter supports the English or Indonesian Location field. Unrecognized or changed editors cancel insertion. Real Google Calendar testing and Store publication remain separate release gates.`)
};

const id_cc_limits = /** @type {(inputs: Cc_LimitsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adapter awal mendukung kolom Lokasi berbahasa Indonesia atau Inggris. Jika editor tidak dikenali atau berubah, penyisipan dibatalkan. Pengujian Google Calendar nyata dan publikasi Store masih merupakan gerbang rilis terpisah.`)
};

/**
* | output |
* | --- |
* | "The initial adapter supports the English or Indonesian Location field. Unrecognized or changed editors cancel insertion. Real Google Calendar testing and Sto..." |
*
* @param {Cc_LimitsInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cc_limits = /** @type {((inputs?: Cc_LimitsInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cc_LimitsInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cc_limits(inputs)
	return en_cc_limits(inputs)
});